import React, {Component} from "react"
import {connect} from "react-redux"
import {setCurrentAccount} from "../dispatch"
import {EVENT_OPEN_ACCOUNT_SELECTION_MODAL} from "../constants"
import {routerActions} from "react-router-redux"
import ErrorAlert from "../components/ErrorAlert"
import {RxEmitter} from "rxemitter"
import {predicateFunctions} from "./AuthWrappers"

function mapStateToProps(state, ownProps) {

  const user = state.user
  return {
    user
  }
}

const mapDispatchToProps = {
  setCurrentAccount,
  replace: routerActions.replace
}

class WelcomeView extends Component {

  constructor(data){
    super(data)
    this.state={

    }
  }

  componentDidMount(){
    const {replace, user} = this.props

    const currentAccount = user.currentEnterpriseAccount

    if(predicateFunctions.UserIsAdminOrOps(user)){
      replace('/admin/enterprise')
    }else if(currentAccount){
      replace('/dashboard')
    }else{
      console.log('emitting EVENT_OPEN_ACCOUNT_SELECTION_MODAL')
      RxEmitter.emit(EVENT_OPEN_ACCOUNT_SELECTION_MODAL)
    }


  }

  render() {

    const error = this.state.message?{message:this.state.message}:null
    return (
      <div>
        <ErrorAlert error={error}/>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeView)



// WEBPACK FOOTER //
// ./src/routes/WelcomeView.js